import classNames from "classnames"
import useScrollIntoView from "hooks/useScrollIntoView"
import { useEffect, useRef, useState } from "react"
import { Link } from "react-router-dom"
import { t } from "translations"
import css from "./AppCard.module.scss"
import AppIcon from "./AppIcon"
import { AppInstallBtn } from "./AppInstallBtn"
import Img from "./Img"
import { Column, Row } from "./Layout"
import Rating from "./Rating"
import Video from "./Video"

const AppCard = ({
  id,
  packageName,
  title,
  versionCode,
  score = 0,
  isPartnerApp = false,

  // assets
  icon,
  headerImage,
  video,
  videoImage,
  videoPreview,

  // Look and feel
  cardType = "default",
  showIcon = true,
  showBanner = false,
  showVideo = false,

  app = null, // for reporting
  appCollection = null, // for reporting
  tab = null // for reporting
}) => {
  const appCardRef = useRef()
  const inView = useScrollIntoView(appCardRef)
  const [reportedInView, setReportedInView] = useState(false)
  useEffect(() => {
    if (!inView || reportedInView) return

    setReportedInView(true)
  }, [inView, reportedInView])

  if (showBanner && showVideo) showBanner = false // Prefer video over banner
  if (showVideo && !videoPreview) {
    // fallback to banner if there is no video
    showVideo = false
    showBanner = true
  }

  let iconSize = cardType === "small" ? 42 : 48
  if ((showBanner || showVideo) && cardType === "small") iconSize = 36

  return (
    <div ref={appCardRef} className={css.appCard}>
      {showBanner && (
        <Link to={`/app/${id}`} className={css.banner} margin="bottom-md">
          <Img
            src={headerImage}
            fallbackImg="/img/app_banner_fallback.svg"
            alt={title}
          />
        </Link>
      )}

      {showVideo && (
        <Link
          to={`/app/${id}`}
          className={css.video}
          margin="bottom-md"
          sf="mc"
        >
          <Video src={videoPreview} poster={videoImage} />
        </Link>
      )}

      <Row className={css.infoGroup} align="ml">
        <Link className={css.info} to={`/app/${id}`} sf="ml" col="1">
          {showIcon && <AppIcon src={icon} size={iconSize} />}
          <Column className={css.titleGroup} col={1} gap="xxs">
            <h5 className={classNames(css.appName, "ellipsis")}>{title}</h5>
            {<Rating value={score} showRating={true} />}
            {cardType !== "small" && (
              <div className={css.readMore}>{t("read_more")}</div>
            )}
          </Column>
        </Link>

        <AppInstallBtn
          appId={id}
          packageName={packageName}
          versionCode={versionCode}
          isPartnerApp={isPartnerApp}
          type={"small"}

          app={app}
          appCollection={appCollection}
          tab={tab}
        />
      </Row>
    </div>
  )
}

export default AppCard
